/**

Sends data to the Event Viewer component (ws-event-viewer) by dispatching a CustomEvent with the provided parameters.
@param {object} data - The data to be sent to the Event Viewer.
@param {string} event - The name of the event to be sent to the Event Viewer.
@param {string} name - The name of the project.
@param {string} sender - The sender of the data to be sent to the Event Viewer.
@param {string} senders - A list of senders of the data to be sent to the Event Viewer.
@returns {void}
*/
const reportToEventViewer = ({
	project,
	payload,
	event,
	...additionalAttributes
}) => {
	const report = () => {
		// dispatch data for the Event Viewer (ws-event-viewer)
		window.dispatchEvent(
			new CustomEvent('eventViewerData', {
				detail: {
					common: {
						event,
						payload,
						source: 'ws-tagging',
						project,
						...additionalAttributes
					}
				}
			})
		);
	};
	if (window?.DDC?.WidgetData?.['ws-event-viewer']?.ready) {
		report();
	} else {
		window.addEventListener(
			'wsEventViewerReady',
			() => {
				report();
			},
			{
				once: true
			}
		);
	}
};

export default reportToEventViewer;
